module.exports = __webpack_public_path__ + "img/other_funding.7fd9b987.svg";